"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.495 3.505a.7.7 0 0 1 0 .99l-16 16a.7.7 0 0 1-.99-.99l16-16a.7.7 0 0 1 .99 0M6.212 4.4A1.8 1.8 0 0 0 4.4 6.213l.03 4.805a2.3 2.3 0 0 0 .673 1.612l1.161 1.161a.7.7 0 1 1-.99.99l-1.16-1.161a3.7 3.7 0 0 1-1.084-2.593L3 6.221A3.2 3.2 0 0 1 6.22 3l4.805.03a3.7 3.7 0 0 1 2.593 1.083l.29.29.871.871a.7.7 0 1 1-.99.99l-1.16-1.16a2.3 2.3 0 0 0-1.613-.674zm11.352 4.65a.7.7 0 0 1 .99 0l1.362 1.362a3.7 3.7 0 0 1 0 5.233l-4.272 4.272a3.7 3.7 0 0 1-5.233 0l-1.362-1.362a.7.7 0 1 1 .99-.99l1.362 1.362a2.3 2.3 0 0 0 3.253 0l4.272-4.272a2.3 2.3 0 0 0 0-3.253l-1.362-1.362a.7.7 0 0 1 0-.99",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.34 8.18a1.073 1.073 0 1 1-2.146 0 1.073 1.073 0 0 1 2.145 0"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UntagIcon24.js.map